// Translation: Interface > Copy button (Arabic)
export default Object.freeze({
	idle: '',
	success: ''
})
